"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _react = _interopRequireDefault(require("react"));
var _HBBannerBase = _interopRequireDefault(require("../HBBanner/HBBannerBase"));
var _HBAvatarAI = _interopRequireDefault(require("../HBAvatarAI/HBAvatarAI"));
var _mixins = require("../../styles/mixins");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _HBBanner = require("./HBBanner.styles");
var _excluded = ["actionTextTransform", "primaryActionTheme"];
var gradientBorderWidth = '1px';
var AIBanner = function AIBanner(props) {
  var _props$actionTextTran = props.actionTextTransform,
    actionTextTransform = _props$actionTextTran === void 0 ? 'none' : _props$actionTextTran,
    _props$primaryActionT = props.primaryActionTheme,
    primaryActionTheme = _props$primaryActionT === void 0 ? 'button-link-blue' : _props$primaryActionT,
    restProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement(StyledHBBanner, (0, _extends2["default"])({
    icon: function icon() {
      return /*#__PURE__*/_react["default"].createElement(_HBAvatarAI["default"], {
        size: "sm"
      });
    },
    primaryActionTheme: primaryActionTheme
  }, restProps, {
    accentLine: _mixins.aiAccentLineGradient.join(''),
    background: [_mixins.aiInlineFill.join(''), _colors["default"].white].join(', '),
    gradientBorderWidth: gradientBorderWidth,
    actionTextTransform: actionTextTransform
  }));
};
var _default = exports["default"] = AIBanner;
var StyledHBBanner = (0, _styledComponents["default"])(_HBBannerBase["default"]).withConfig({
  displayName: "AIBanner__StyledHBBanner",
  componentId: "sc-q7j1ew-0"
})(["", ";"], (0, _mixins.adaptiveGradientBorder)(_mixins.aiInlineStroke, _HBBanner.BannerBorderRadiusValue.join(''), gradientBorderWidth));
//# sourceMappingURL=AIBanner.js.map